import React, { useEffect } from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import { BLANK_RULE_TEMPLATE_ID } from '../../../helpers/rules';
import RadioTagSelect from '../../FormFields/RadioTagSelect';
import TagSelect from '../../FormFields/TagSelect';
import { toSentence } from '../../../helpers/strings';

const BinaryTargetTypeSelect = ({
    controlValue,
    errors,
    label,
    name,
    onRenderable,
    onTargetChange,
    onTargetTypeChange,
    ruleId,
    ruleTemplateId,
    target,
    targetType,
    touched,
    value,
    ...props
}) => {
    const hasId = ruleId || (ruleTemplateId && ruleTemplateId !== BLANK_RULE_TEMPLATE_ID);
    const isRenderable = !hasId || (hasId && target === controlValue);

    useEffect(() => {
        if (!isRenderable || targetType.loading || targetType.data.length) {
            return;
        }
        onRenderable();
    }, [isRenderable, targetType.loading, targetType.data.length]);

    if (!isRenderable) {
        return null;
    }

    const hasTargetError = touched.target && Boolean(errors.target);
    const hasError = hasTargetError || Boolean(targetType.error);
    let helperText = null;
    if (hasError) {
        helperText = toSentence([
            touched.target && errors.target,
            targetType.error
        ]);
    } else if (ruleId) {
        helperText = `The rule target value is read-only. To choose a value other than "${label}", create a new Rule.`;
    }

    let inputProps = null;
    let Component = TagSelect;
    if (!hasId) {
        Component = RadioTagSelect;
        inputProps = {
            RadioProps: {
                name:     'target',
                onChange: onTargetChange,
                value:    controlValue
            },
            required: true,
            target
        };
    }

    return (
        <Component
            error={hasError}
            helperText={helperText}
            label={label}
            name={name}
            onChange={onTargetTypeChange}
            touched={touched}
            {...inputProps}
            value={value}
            {...props}
        />
    );
};

BinaryTargetTypeSelect.defaultProps = {
    errors:             {},
    onRenderable:       () => {},
    onTargetChange:     () => {},
    onTargetTypeChange: () => {},
    targetType:         {
        data: []
    },
    touched: {},
    value:   []
};

BinaryTargetTypeSelect.propTypes = {
    controlValue: string,
    errors:       shape({
        target: string
    }),
    label:              string.isRequired,
    name:               string,
    onRenderable:       func,
    onTargetChange:     func,
    onTargetTypeChange: func,
    ruleId:             string,
    ruleTemplateId:     string,
    target:             string,
    targetType:         shape({
        error:   string,
        data:    array,
        loading: bool
    }),
    touched: shape({
        target: bool
    }),
    value: array
};

export default BinaryTargetTypeSelect;
